import { ManuteRequestConfig } from '@/api/types';
import { SampleQueryParams } from '@/api/requests/proposal/types';
import { SampleRequest, SampleUpdateStatusRequest } from '@/store/modules/proposal/types';

/**
 * Request to find all samples.
 * @param params
 */
export const ALL = (params?: SampleQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/samples',
    params: {
        page_size: 50,
        ...params,
    },
});

/**
 * Request to save a new sample.
 * @param data
 */
export const STORE = (data: SampleRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: '/samples',
    data,
});

/**
 * Request to find a sample by id.
 * @param sampleId
 */
export const FIND = (sampleId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/samples/${sampleId}`,
});

/**
 * Request to update an existing sample.
 * @param sampleId
 * @param data
 */
export const UPDATE = (sampleId: number, data: SampleRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/samples/${sampleId}`,
    data,
});

/**
 * Request to update an existing sample's status.
 * @param sampleId
 * @param data
 */
export const UPDATE_STATUS = (sampleId: number, departmentId: number, data: SampleUpdateStatusRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: `/samples/${sampleId}/departments/${departmentId}/update-status`,
    data,
});

/**
 * Request to download an existing sample as pdf.
 * @param sampleId
 */
export const DOWNLOAD_SAMPLE_AS_PDF = (sampleId: number, params?: SampleQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: `/samples/${sampleId}/download-as-pdf`,
    params,
    responseType: 'blob'
});

/**
 * Download the proposal as pdf
 * @param proposalId
 * @param data
 */
export const GET_SAMPLE_PDF_AS_LINK = (sampleId: number, params?: SampleQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: `/samples/${sampleId}/pdf-as-link`,
    params
});